import { defineMessages } from 'react-intl';

export const taxReasonsMessages = defineMessages({
    taxReasons: {
        id: 'tax-reasons',
        defaultMessage: 'Tax reasons',
    },
    taxReason: {
        id: 'tax-reason',
        defaultMessage: 'Tax reason',
    },
    reasons: {
        id: 'reasons',
        defaultMessage: 'Reasons',
    },
    reason: {
        id: 'reason',
        defaultMessage: 'Reason',
    },
    value: {
        id: 'value',
        defaultMessage: 'Value',
    },
    isDefault: {
        id: 'is-default',
        defaultMessage: 'Is default',
    },
    isActive: {
        id: 'is-active',
        defaultMessage: 'Is active',
    },
    createTaxReasonSuccess: {
        id: 'create-tax-reason-success',
        defaultMessage: 'Tax reason created',
    },
    createTaxReasonSuccessDescription: {
        id: 'create-tax-reason-success-description',
        defaultMessage: 'Tax reason {entry} has been successfully created.',
    },
    addTaxReasonSubtitle: {
        id: 'add-tax-reason-subtitle',
        defaultMessage: 'Create a new tax reason',
    },
    deleteTaxReason: {
        id: 'delete-tax-reason',
        defaultMessage: 'Delete tax reason',
    },
    deleteTaxReasonSuccess: {
        id: 'delete-tax-reason-success',
        defaultMessage: 'Tax reason deleted',
    },
    deleteTaxReasonSuccessDescription: {
        id: 'delete-tax-reason-success-description',
        defaultMessage: 'The tax reason has been successfully deleted.',
    },
    confirmDeleteTaxReason: {
        id: 'confirm-delete-tax-reason',
        defaultMessage: 'Are you sure you want to delete this tax reason? This action cannot be undone.',
    },
    deleteTaxReasonSubtitle: {
        id: 'delete-tax-reason-subtitle',
        defaultMessage: 'Permanently delete tax reason {entity}',
    },
    editTaxReasonSubtitle: {
        id: 'edit-tax-reason-subtitle',
        defaultMessage: 'Edit tax reason {entity}',
    },
    updateTaxReasonSuccess: {
        id: 'update-tax-reason-success',
        defaultMessage: 'Tax reason updated',
    },
    updateTaxReasonSuccessDescription: {
        id: 'update-tax-reason-success-description',
        defaultMessage: 'Tax reason {entity} has been successfully updated.',
    },
});
